const data = {
  webapps :[
    {
      id: 1,
      title: "Diamelle",
      divlop:"ReactJs /NodeJs/Redux/Express/Mongodb/Alan AI",
      discription:"Ce site présente mon projet de PFE il est développé par moi-même avant la réalisation j'ai lancer une recherche sur l'expérience utilisateur avec des sites du même intérêt les couleurs, la disposition des produits sont choisies pour des raisons bien précises  Un thème noir pour le confort des yeux ,et bien évidemment la tendance 'darke mode' les utilisateurs aime ce asspet nouveau ,la page produit et en blanc sur un font blanc l'attention sera sur le continue(l'objet) de cette façon l'attention de client sera sur l'article ainsi ce site comporte un agent vocal intelligent  (chat Voice) c'est pour rendre le processus de commande plus rapide ce qu'ont appelle le V-commerce (commerce vocal)",
      img:"../diamelle/diamelle.png",
      imgp:"../diamelle/toutepage.png",

        imgo:"../diamelle/produxct.png",
        imgs:"../diamelle/FireShot Capture 011 - React App - localhost.png",
        imgt:"../diamelle/signin.png",
        imgth:"../diamelle/dash.png"
    },
    {
      id: 2,
      title: "Ecommerce Web Site",
      divlop:"ReactJs /NodeJs/Redux/Express/Mongodb",
      discription:"ce site présente le premier projet que j'ai  créé dans le but d'apprendre les technologies mern stack ,il est développé par moi-même c'est un site e-commerce ,au cours de ce projet j'ai maitrisé le react-redux ,la notion de store et du flux de données unidirectionnel  ",

      img:
        "../diamelle/ecommerce.png",
        imgo:"../diamelle/ecommerce.png",
        imgs:"../diamelle/ecomprodp.png",
        imgt:"../diamelle/ecomprodcard.png",
        imgth:"../diamelle/ecomsig.png"
    },
    {
      id: 3,
      title: " Social média app",
      divlop:"ReactJs /NodeJs/ContextAPi/Express/Mongodb ce site est en cours de réalisation",
      discription:"Ce site est en cours de réalisation à l'aide d'un tutoriel afin d'apprendre l'utilisation de contexte API l'architecture de ce projet est différentes par rapport à mes projets sa m'aider à maitriser le SCSS je suis entrains d'apprendre comment faire transiter des propos d'un composant parent à un composant enfant sans prendre en compte les possibles composants intermédiaires.",

      img:
        "../diamelle/registerso.png",
        imgo:"../diamelle/registerso.png",
        imgs:"../diamelle/signinso.png",
        imgt:"../diamelle/Social Média.png",
    },
   
  ],
};

export default data;  